import React, { useState } from 'react'
import { Select, Space } from 'antd';
import styled from 'styled-components';

const { Option } = Select;

function SelectMultipleWithSearch(props) {
    const [searchValue, setSearchValue] = useState('');

    const handleSearch = (value) => {
        setSearchValue(value);
    };

    const handleSelect = (value) => {
        if (props.mode) {
            if (value.includes("ALL") || value.includes("all")) {
                props.setFieldValue(props.name, ["all"]);
            } else {
                props.setFieldValue(
                    props.name,
                    value.filter((v) => v !== "ALL" && v !== "all")
                );
            }
        } else {
            props.setFieldValue(props.name, value);
            if (props?.handlePopulateData != undefined) {
                props.handlePopulateData(value);
            }
        }
    };

    const filterOption = (input, option) => {
        const { value, children } = option.props;
        return children.toString().toLowerCase().includes(input.toLowerCase());
    };

    return (
        <SpaceItem wrap gap={props.gap} mr={props.mr} mb={props.mb} $fill={props.width === "100%"}>
            <ItemSelect
                showSearch
                mode={props?.mode ? "multiple" : "single"}
                size={props.size ? props.size : "large"}
                placeholder={props.placeholder ? props.placeholder : "Select"}
                disabled={props.disabled}
                style={{ width: props.width ? props.width : 230 }}
                popupMatchSelectWidth={false}
                dropdownStyle={{
                    minWidth: 240,
                    borderRadius: 10,
                    boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                    padding: "4px",
                }}
                listHeight={220}
                onChange={handleSelect}
                onSearch={handleSearch}
                filterOption={filterOption}
                value={props.value}
                bradius={props.bradius}
                popupClassName="custom-select-dropdown"
            >
                {props.options?.map((i, index) =>
                    <Option key={index} value={i.value}>{i.label}</Option>
                )}
            </ItemSelect>
        </SpaceItem>
    );
}

export default SelectMultipleWithSearch;

const SpaceItem = styled(Space)`
    position: relative;
    width: ${({ $fill }) => $fill ? '100%' : 'auto'};
    gap: ${({ gap }) => gap ? gap : '8px'};
    margin-right: ${({ mr }) => mr ? mr : "unset"};
    margin-bottom: ${({ mb }) => mb ? mb : "unset"};
    & .ant-space-item {
        width: 100%;
    }
`;

const ItemSelect = styled(Select)`
    & .ant-select-selector {
        border-radius: ${({ bradius }) => bradius ? bradius : "8px !important"};
        padding-left: ${({ is_icon }) => is_icon ? "20px !important" : 'unset'};
        min-height: 34px !important;
        font-size: 13px !important;
        transition: border-color 0.15s ease, box-shadow 0.15s ease !important;
    }
    & .ant-select-selection-placeholder {
        color: #d9d9d9 !important;
        font-size: 13px;
        font-weight: 400;
    }
    & .ant-select-arrow {
        color: #bbb !important;
    }
    & .ant-select-selection-item {
        font-size: 13px !important;
        font-weight: 500;
    }
`;
